import React from 'react';
import { JobsiteAnnouncement } from 'apollo/generated/client-operations';
import { Document } from 'components/document';
import { AnnouncementSection } from './AnnouncementSection';

export const classes = {
  container:
    'odin-border odin-border-gray-200 odin-shadow-sm odin-rounded-lg odin-p-6 odin-space-y-2',
  fileInfo: 'odin-text-xs odin-text-gray-600',
};

export function AnnouncementAttachments({
  announcement,
}: {
  announcement: Partial<JobsiteAnnouncement>;
}): React.ReactElement {
  return (
    <AnnouncementSection id="attachments" title="Attachments">
      <div className="odin-flex odin-flex-col md:odin-grid odin-grid-cols-2 odin-gap-3">
        {announcement.files?.map((file) => {
          return (
            <div className={classes.container} key={file.fileId}>
              <Document file={file} />
              <div className={classes.fileInfo}>FileId: {file.fileId}</div>
            </div>
          );
        })}
      </div>
    </AnnouncementSection>
  );
}
